module.exports = __webpack_public_path__ + "static/planifeye-export-cbb9f8ea386ba58eb4b75ad101030f11.mp4";